import { render } from "./LandCover.vue?vue&type=template&id=0ff3d1ea"
import script from "./LandCover.vue?vue&type=script&lang=js"
export * from "./LandCover.vue?vue&type=script&lang=js"

import "./LandCover.vue?vue&type=style&index=0&id=0ff3d1ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__